import type { CityConfig } from "../city-template/types";

export const dundalkConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Maryland Department of Health Vital Statistics Administration. Online, mail, or in-person at the Baltimore vital records office.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through the Maryland Department of Health Vital Statistics. Required for estate, legal, and survivor benefit matters.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request certified marriage records from the Baltimore County Circuit Court Clerk. Required for name change passport applications.", url: "https://www.baltimorecountymd.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Baltimore County Circuit Court. Required for name change passport corrections.", url: "https://www.baltimorecountymd.gov/" },
  ],
  city: "Dundalk",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "dundalk",
  route: "/cities/dundalk",
  title: "Emergency Passport Dundalk, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Dundalk, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Dundalk, Essex, Middle River, and Rosedale residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Dundalk, MD",
  heroSubtitle: "Dundalk travelers — from Sparrows Point workers to Baltimore County families to Patapsco River residents — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of eastern Baltimore County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic view of Dundalk Maryland waterfront area near Patapsco River with industrial heritage, open green spaces, modern suburban neighborhoods, residential streets, warm afternoon golden hour lighting, professional Baltimore County photography, no visible text or people, clean natural landscape and community atmosphere\u0026width=1800\u0026height=700\u0026seq=dundalk-hero-001\u0026orientation=landscape",
  heroImageAlt: "View of Dundalk Maryland waterfront area near Patapsco River with suburban neighborhoods",
  geoPosition: "39.2506;-76.5186",
  geoPlacename: "Dundalk, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 55–65 minutes from Dundalk via I-95 S",
  },
  nearbyCitiesZips: [
    { name: "Dundalk", zips: "21222" },
    { name: "Essex", zips: "21221" },
    { name: "Middle River", zips: "21220" },
    { name: "Rosedale", zips: "21237" },
    { name: "Edgemere", zips: "21219" },
    { name: "Sparrows Point", zips: "21219" },
    { name: "Baltimore", zips: "21201, 21202, 21205, 21206, 21209, 21210, 21211, 21212, 21213, 21214, 21215, 21216, 21217, 21218, 21222, 21223, 21224, 21225, 21226, 21227, 21228, 21229, 21230, 21231, 21234, 21236, 21237, 21239, 21251" },
    { name: "Parkville", zips: "21234" },
    { name: "Overlea", zips: "21236" },
    { name: "Perry Hall", zips: "21128" },
    { name: "White Marsh", zips: "21162" },
    { name: "Towson", zips: "21204, 21252, 21284, 21285, 21286" },
    { name: "Catonsville", zips: "21228, 21229, 21250" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Dundalk and eastern Baltimore County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-ship-line", title: "Cruise & Port Travel", desc: "Serving Baltimore Port cruise passengers and maritime workers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Baltimore, MD", route: "/cities/baltimore" },
    { name: "Emergency passport help in Essex, MD", route: "/cities/essex" },
    { name: "Urgent passport services in Towson, MD", route: "/cities/towson" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Dundalk, Maryland remotely via secure registered courier. We do not have a walk-in office in Dundalk — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Dundalk and eastern Baltimore County travelers without the drive to downtown DC.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, MD 20814",
  fpcOfficeDistance: "Serving Dundalk, Essex, Middle River, Rosedale, and greater eastern Baltimore County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Dundalk area and eastern Baltimore County. From the historic neighborhoods near the Patapsco River to the residential communities of Essex and Middle River, from the industrial waterfront of Sparrows Point to the family-friendly streets of Rosedale — we serve all of eastern Baltimore County.",
  nearbyCitiesIntro: "We serve Dundalk and nearby communities including Essex, Middle River, Rosedale, Edgemere, Sparrows Point, Parkville, Overlea, and Perry Hall. We also serve Baltimore, Towson, and Catonsville residents who prefer our expedited service.",
  howItWorksIntro: "Most Dundalk travelers complete everything online and ship documents overnight. No need to drive 55–65 minutes to downtown DC or navigate Baltimore Beltway traffic.",
  mistakesIntro: "Dundalk is a major Baltimore County working-class community with many families and cruise travelers. Here are the most common passport mistakes we see from Dundalk travelers.",
  testimonialsIntro: "Dundalk travelers — from cruise passengers to maritime workers to Baltimore County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Dundalk, MD? Here are the most common ones we hear from eastern Baltimore County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for cruise and family travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 55–65 min to downtown DC", "Full day commitment — challenging for working families"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Dundalk travelers with immediate departure needs — as fast as 24 hours. Critical for cruise departures and last-minute family travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Cruise and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Dundalk adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Dundalk address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Dundalk residents and families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Dundalk residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Dundalk families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Dundalk residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Dundalk MD", description: "Urgent passport processing for Dundalk Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Dundalk MD", description: "Fast passport renewal for Dundalk Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Dundalk MD", description: "New passport application services for Dundalk Maryland residents applying for their first passport." },
    { name: "Child Passport Dundalk MD", description: "Minor passport services for Dundalk Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Dundalk, MD",
      rating: 5,
      text: "Cruise to the Bahamas with 7 days notice. Fast Passport Center processed our family's three passports in 4 days. We didn't have to miss our cruise — and we didn't have to drive to DC.",
      service: "Family Passport Bundle",
    },
    {
      name: "Robert K.",
      location: "Sparrows Point, MD",
      rating: 5,
      text: "Work assignment in Canada with 5 days notice. They reviewed my renewal application, caught a minor issue, and had my passport in my hands in 48 hours.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sarah L.",
      location: "Essex, MD",
      rating: 5,
      text: "Family vacation to Mexico with 9 days notice. The agent handled everything for our four passports. Just shipped from the local UPS Store and we were set.",
      service: "Family Passport Bundle",
    },
    {
      name: "Chris D.",
      location: "Middle River, MD",
      rating: 5,
      text: "Lost my passport before a trip to Jamaica. They answered the phone immediately and had a replacement in my hands in 36 hours. Incredible service.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "dundalk-1",
      name: "Dundalk Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7875 Wise Ave",
      city: "Dundalk",
      state: "MD",
      zip: "21222",
      phone: "(410) 288-2276",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Dundalk, near the intersection of Wise Avenue and Merritt Boulevard",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Dundalk acceptance facility. Appointments required — book 1–2 weeks in advance. Accessible from I-695.",
      icon: "ri-mail-line",
    },
    {
      id: "dundalk-2",
      name: "Essex Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "410 Eastern Blvd",
      city: "Essex",
      state: "MD",
      zip: "21221",
      phone: "(410) 687-4400",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Essex, approximately 3 miles north of Dundalk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Essex and Middle River residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "dundalk-3",
      name: "Middle River Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1100 Middle River Rd",
      city: "Middle River",
      state: "MD",
      zip: "21220",
      phone: "(410) 687-3170",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Middle River, approximately 4 miles northeast of Dundalk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Middle River and eastern Baltimore County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "dundalk-4",
      name: "Baltimore County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "111 W Chesapeake Ave",
      city: "Towson",
      state: "MD",
      zip: "21204",
      phone: "(410) 887-2600",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Towson, approximately 12 miles northwest of Dundalk",
      website: "https://www.baltimorecountymd.gov/",
      websiteLabel: "Baltimore County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 55–65 min drive to downtown DC", fpc: "No — ship from Dundalk" },
    { feature: "Cruise Travel Support", agency: "No flexibility for cruise schedules", fpc: "Yes — we understand cruise deadlines" },
    { feature: "Port of Baltimore Cruise Terminal", agency: "No cruise documentation guidance", fpc: "Yes — Baltimore cruise port specialists" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Maritime & Industrial Worker", agency: "No shift worker flexibility", fpc: "Yes — shift worker and maritime travel support" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Dundalk's busy working families and cruise travelers often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Dundalk sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Dundalk and Baltimore County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Dundalk Post Office appointments fill up fast, especially during cruise season and summer travel. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Dundalk residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Dundalk, Essex, or Middle River." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Dundalk or along Merritt Boulevard." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Dundalk address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Dundalk, MD?", a: "Fast Passport Center offers emergency passport processing in Dundalk, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (55–65 minutes from Dundalk) — without you needing to make the drive or fight Baltimore Beltway traffic." },
    { q: "Does Dundalk have its own passport agency?", a: "No — neither Dundalk nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 55–65 minutes from Dundalk via I-95 S. Fast Passport Center's courier service means Dundalk residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Essex or Middle River?", a: "Absolutely. Fast Passport Center serves all of the Dundalk area including Essex, Middle River, Rosedale, Edgemere, and Sparrows Point. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Dundalk, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Dundalk travelers use for international flights?", a: "Most Dundalk residents fly internationally through Baltimore-Washington International (BWI), approximately 25–30 minutes west via I-695. Dulles International (IAD) is 60–70 minutes southwest via I-695 and I-270. Reagan National (DCA) is 55–65 minutes south via I-95. For cruise travelers, the Port of Baltimore is 20–25 minutes west via I-695. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Dundalk?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Dundalk, Essex, Middle River, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Dundalk?", a: "The Dundalk Post Office at 7875 Wise Ave is the primary acceptance facility. The Essex Post Office at 410 Eastern Blvd serves northern Dundalk and Essex. The Middle River Post Office at 1100 Middle River Rd serves eastern Baltimore County. The Baltimore County Clerk's Office at 111 W Chesapeake Ave in Towson also provides passport acceptance. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Dundalk residents should plan ahead, especially for cruise departures and family vacations." },
  ],
  photoLocations: [
    { name: "Walgreens — Dundalk", address: "1400 Merritt Blvd, Dundalk, MD 21222", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Dundalk", address: "7000 Holabird Ave, Dundalk, MD 21222", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "UPS Store — Dundalk", address: "1730 Merritt Blvd, Dundalk, MD 21222", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Rosedale", address: "8640 Pulaski Hwy, Rosedale, MD 21237", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    { name: "MVA — Glen Burnie", address: "6601 Ritchie Hwy NE, Glen Burnie, MD 21062", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Anne Arundel and Baltimore County. REAL ID processing available.", featured: true },
    { name: "MVA — Essex", address: "1338 Eastern Blvd, Essex, MD 21221", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves eastern Baltimore County. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "25–30 minutes from Dundalk via I-695 W",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary departure airport for Dundalk travelers. Southwest Airlines hub with direct flights to major US cities and international connections. Closest for cruise connections.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "55–65 minutes from Dundalk via I-95 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Secondary option for domestic connections to international hubs.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International",
      distance: "60–70 minutes from Dundalk via I-695 W and I-270 W",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for international flights and United Airlines hub connections.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};